module.exports = __webpack_public_path__ + "img/box-arrow-in-up-left.f5207516.svg";